module.exports = __webpack_public_path__ + "static/img/kjhf_add_select_group.bdf2045.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/kjhf_add_select_group.jpeg
// module id = 1237
// module chunks = 0